module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projekt topspacing-big"
  }, [_c('div', {
    staticClass: "header-big"
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 240.823 240.823"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 240.823 240.823",
      "xml:space": "preserve",
      "width": "18px",
      "height": "18px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "id": "Chevron_Right",
      "d": "M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179   l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816   C52.942,116.507,52.942,124.327,57.633,129.007z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.filteredResult.bookingTypeNavn))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-user"
  }, [(_vm.filteredResult && !_vm.filteredResult.adresse.etage && !_vm.filteredResult.adresse.doer) ? _c('p', {
    staticClass: "small-text"
  }, [_vm._v(_vm._s(_vm._f("shorten")(_vm.filteredResult.adresse.vejnavn + ' ' + _vm.filteredResult.adresse.husnummer + ', ' + _vm.filteredResult.adresse.postnummer + ' ' + _vm.filteredResult.adresse.by)))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult && _vm.filteredResult.adresse.etage && !_vm.filteredResult.adresse.doer) ? _c('p', {
    staticClass: "small-text"
  }, [_vm._v(_vm._s(_vm._f("shorten")(_vm.filteredResult.adresse.vejnavn + ' ' + _vm.filteredResult.adresse.husnummer + '. ' + _vm.filteredResult.adresse.etage + ', ' + _vm.filteredResult.adresse.postnummer + ' ' + _vm.filteredResult.adresse.by)))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult && !_vm.filteredResult.adresse.etage && _vm.filteredResult.adresse.doer) ? _c('p', {
    staticClass: "small-text"
  }, [_vm._v(_vm._s(_vm._f("shorten")(_vm.filteredResult.adresse.vejnavn + ' ' + _vm.filteredResult.adresse.husnummer + '. ' + _vm.filteredResult.adresse.doer + ', ' + _vm.filteredResult.adresse.postnummer + ' ' + _vm.filteredResult.adresse.by)))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult && _vm.filteredResult.adresse.etage && _vm.filteredResult.adresse.doer) ? _c('p', {
    staticClass: "small-text"
  }, [_vm._v(_vm._s(_vm._f("shorten")(_vm.filteredResult.adresse.vejnavn + ' ' + _vm.filteredResult.adresse.husnummer + '. ' + _vm.filteredResult.adresse.etage + ' - ' + _vm.filteredResult.adresse.doer + ', ' + _vm.filteredResult.adresse.postnummer + ' ' + _vm.filteredResult.adresse.by)))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("formattedDate")(_vm.filteredResult.fratid)) + " - " + _vm._s(_vm._f("moment")(_vm.filteredResult.tiltid)))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show == 'booking'),
      expression: "show == 'booking'"
    }],
    staticClass: "content padding-bottom-big"
  }, [_c('h5', [_vm._v("Måler")]), _vm._v(" "), _c('div', {
    staticClass: "special-text under-header"
  }, [_c('p', [_vm._v(_vm._s(_vm.filteredResult.maalerType))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.filteredResult.maalernummer))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-x",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    attrs: {
      "for": "målerplacering"
    }
  }, [_vm._v("Målerplacering\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.målerplacering),
      expression: "data.målerplacering"
    }],
    attrs: {
      "type": "text",
      "id": "målerplacering",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.data.målerplacering)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "målerplacering", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('label', {
    attrs: {
      "for": "tidligerestand"
    }
  }, [_vm._v("Tidligere stand\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tidligerestand),
      expression: "data.tidligerestand"
    }],
    attrs: {
      "type": "number",
      "disabled": "disabled",
      "id": "tidligerestand"
    },
    domProps: {
      "value": (_vm.data.tidligerestand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "tidligerestand", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-left": "4px"
    }
  }, [_c('label', {
    attrs: {
      "for": "aktuelstand"
    }
  }, [_vm._v("Aktuel stand\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tidligereaktuelstand),
      expression: "data.tidligereaktuelstand"
    }],
    attrs: {
      "type": "number",
      "id": "aktuelstand"
    },
    domProps: {
      "value": (_vm.data.tidligereaktuelstand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "tidligereaktuelstand", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.data.tidligerestand > 0) ? _c('p', {
    staticStyle: {
      "font-size": "0.9rem",
      "margin-top": "-5px",
      "padding-left": "2px",
      "font-style": "italic",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Forventet: " + _vm._s(Math.floor(_vm.beregnForventetForbrugForDato(_vm.filteredResult.aflaesningsdato, _vm.filteredResult.fratid, _vm.filteredResult.aarsforbrug)) + _vm.data.tidligerestand))]) : _vm._e()])]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("Ny måler")]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": _vm.childClicked
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('label', {
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Nummer\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nummer),
      expression: "data.nummer"
    }],
    attrs: {
      "type": "text",
      "id": "number"
    },
    domProps: {
      "value": (_vm.data.nummer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nummer", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-2 cell"
  }, [_c('button', {
    staticClass: "button barcode",
    attrs: {
      "data-open": "barcodeModal"
    },
    on: {
      "click": _vm.scanClick
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 28.046 28.046"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 28.046 28.046",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('rect', {
    attrs: {
      "y": "4.877",
      "width": "3.161",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.631",
      "y": "4.877",
      "width": "3.165",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "5.141",
      "y": "4.877",
      "width": "1.579",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.995",
      "y": "4.877",
      "width": "1.581",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "17.766",
      "y": "4.877",
      "width": "1.576",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24.486",
      "y": "4.877",
      "width": "1.584",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.255",
      "y": "4.877",
      "width": "0.791",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "8.765",
      "y": "4.877",
      "width": "4.746",
      "height": "18.292",
      "fill": "#292929"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "small-4 cell",
    staticStyle: {
      "padding-left": "6px"
    }
  }, [_c('label', {
    attrs: {
      "for": "stand"
    }
  }, [_vm._v("Aktuel stand\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.aktuelstand),
      expression: "data.aktuelstand"
    }],
    attrs: {
      "type": "text",
      "id": "stand"
    },
    domProps: {
      "value": (_vm.data.aktuelstand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "aktuelstand", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Årsag til ny tid\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nytidselect),
      expression: "data.nytidselect"
    }],
    attrs: {
      "id": "select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "nytidselect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ingen valgt")]), _vm._v(" "), _vm._l((_vm.timetypes), function(timetype) {
    return _c('option', {
      key: timetype.id,
      domProps: {
        "selected": _vm.selected,
        "value": timetype.id
      }
    }, [_vm._v("\n                    " + _vm._s(timetype.navn) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-12 cell"
  }, [_c('button', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("Gem")])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show == 'customer'),
      expression: "show == 'customer'"
    }],
    staticClass: "content padding-bottom-big"
  }, [_vm._m(1), _vm._v(" "), (_vm.filteredResult.kunde) ? _c('div', {
    staticClass: "customer-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.filteredResult.kunde.navn))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.filteredResult.adresse.vejnavn) + " " + _vm._s(_vm.filteredResult.adresse.husnummer) + ", " + _vm._s(_vm.filteredResult.adresse.postnummer) + " " + _vm._s(_vm.filteredResult.adresse.by))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.filteredResult.by))]), _vm._v(" "), (_vm.filteredResult.kunde.email != null || _vm.filteredResult.kunde.email != undefined) ? _c('p', [_vm._v(_vm._s(_vm.filteredResult.kunde.email))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult.kunde.email == null || _vm.filteredResult.kunde.email == undefined) ? _c('p', [_c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.email),
      expression: "data.email"
    }],
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.data.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "email", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.filteredResult.kunde.mobil != null || _vm.filteredResult.kunde.mobil != undefined) ? _c('p', [_vm._v(_vm._s(_vm.filteredResult.kunde.mobil))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult.kunde.mobil == null || _vm.filteredResult.kunde.mobil == undefined) ? _c('p', [(_vm.filteredResult.kunde.email != null || _vm.filteredResult.kunde.email != undefined) ? _c('br') : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Mobil\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.mobil),
      expression: "data.mobil"
    }],
    attrs: {
      "type": "text",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.data.mobil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "mobil", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.filteredResult.kunde.email == null || _vm.filteredResult.kunde.email == undefined || _vm.filteredResult.kunde.mobil == null || _vm.filteredResult.kunde.mobil == undefined) ? _c('a', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("Gem")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.filteredResult.kunde) ? _c('div', {
    staticClass: "customer-info no-info"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Der findes ingen oplysninger på kunden")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show == 'notes'),
      expression: "show == 'notes'"
    }],
    staticClass: "content padding-bottom-big"
  }, [_c('h5', [_vm._v("Noter")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteselect),
      expression: "noteselect"
    }],
    attrs: {
      "id": "select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.noteselect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1",
      "disabled": "disabled"
    }
  }, [_vm._v("Ingen valgt")]), _vm._v(" "), _vm._l((_vm.notetypes), function(notetype) {
    return _c('option', {
      key: notetype.id,
      domProps: {
        "value": notetype.navn
      }
    }, [_vm._v("\n                " + _vm._s(notetype.navn) + "\n            ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("Gem")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show == 'images'),
      expression: "show == 'images'"
    }],
    staticClass: "content padding-bottom-big"
  }, [_c('div', {
    staticClass: "addFile"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "fileUpload",
      "accept": "image/*",
      "capture": ""
    },
    on: {
      "change": _vm.gotUpload
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('p', [_vm._v("Tilføj billede")])]), _vm._v(" "), _c('div', {
    staticClass: "addScreenshot"
  }, [(_vm.webcam.active) ? _c('div', [_c('web-cam', {
    ref: "webcam",
    attrs: {
      "deviceId": _vm.webcam.selectedCameraId,
      "height": 200
    },
    on: {
      "cameras": _vm.getAvailableCameras
    }
  }), _vm._v(" "), (_vm.webcam.availableCameras) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webcam.selectedCameraId),
      expression: "webcam.selectedCameraId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.webcam, "selectedCameraId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Vælg Kamera")]), _vm._v(" "), _vm._l((_vm.webcam.availableCameras), function(camera) {
    return _c('option', {
      key: camera.deviceId,
      domProps: {
        "value": camera.deviceId
      }
    }, [_vm._v("\n                        " + _vm._s(camera.label) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button call-to-action",
    on: {
      "click": function($event) {
        return _vm.capture_screenshot()
      }
    }
  }, [_vm._v("Tag screenshot")])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.toggleCamera()
      }
    }
  }, [_vm._v(_vm._s(_vm.webcam.text))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-x"
  }, _vm._l((_vm.localImages), function(upload) {
    return _c('FormUpload', {
      key: upload.id || _vm.mongoid,
      attrs: {
        "upload": upload
      },
      on: {
        "removeUpload": function($event) {
          return _vm.doremoveUpload(upload.id)
        }
      }
    })
  }), 1)]), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "auto cell",
    class: {
      'active-item': _vm.show == 'booking'
    },
    on: {
      "click": _vm.goToBooking
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("date_range")]), _vm._v(" "), _c('p', [_vm._v("Booking")])]), _vm._v(" "), _c('div', {
    staticClass: "auto cell",
    class: {
      'active-item': _vm.show == 'customer'
    },
    on: {
      "click": _vm.goToCustomer
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(" "), _c('p', [_vm._v("Kunde")])]), _vm._v(" "), _c('div', {
    staticClass: "auto cell",
    class: {
      'active-item': _vm.show == 'notes'
    },
    on: {
      "click": _vm.goToNotes
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Layer_1",
      "x": "0px",
      "y": "0px",
      "width": "23px",
      "height": "25px",
      "viewBox": "0 0 128 128",
      "enable-background": "new 0 0 128 128",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M8,112V16c0-4.414,3.594-8,8-8h80c4.414,0,8,3.586,8,8v47.031l8-8V16c0-8.836-7.164-16-16-16H16C7.164,0,0,7.164,0,16v96    c0,8.836,7.164,16,16,16h44v-8H16C11.594,120,8,116.414,8,112z M88,24H24v8h64V24z M88,40H24v8h64V40z M88,56H24v8h64V56z M24,80    h32v-8H24V80z M125.656,72L120,66.344c-1.563-1.563-3.609-2.344-5.656-2.344s-4.094,0.781-5.656,2.344l-34.344,34.344    C72.781,102.25,68,108.293,68,110.34L64,128l17.656-4c0,0,8.094-4.781,9.656-6.344l34.344-34.344    C128.781,80.188,128.781,75.121,125.656,72z M88.492,114.82c-0.453,0.43-2.02,1.488-3.934,2.707l-10.363-10.363    c1.063-1.457,2.246-2.922,2.977-3.648l25.859-25.859l11.313,11.313L88.492,114.82z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v(" "), _c('p', [_vm._v("Noter")])]), _vm._v(" "), _c('div', {
    staticClass: "auto cell",
    class: {
      'active-item': _vm.show == 'images'
    },
    on: {
      "click": _vm.goToImages
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("camera_alt")]), _vm._v(" "), _c('p', [_vm._v("Billeder")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.overlay),
      expression: "overlay"
    }],
    staticClass: "overlay",
    attrs: {
      "data-toggle": "bottommenu",
      "aria-controls": "bottommenu"
    },
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), (_vm.deviation === true) ? _c('div', {
    staticClass: "alert-message"
  }, [_c('div', {
    staticClass: "align-alert-item"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("warning")]), _vm._v(" "), _c('h5', [_vm._v("Der er en afvigelse på mere end " + _vm._s(_vm.maxDeviation) + "%")]), _vm._v(" "), _c('button', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.closeAlert
    }
  }, [_vm._v("Luk")])])]) : _vm._e(), _vm._v(" "), (_vm.popup == true) ? _c('div', {
    staticClass: "popup-message"
  }, [_vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_vm._v("receipt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Kundeoplysninger   "), _c('i', {
    staticClass: "material-icons person-icon"
  }, [_vm._v("person")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-item"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('h5', [_vm._v("Gemt!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e513906a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projekt.vue
// module id = 1014
// module chunks = 1